module.exports = __webpack_public_path__ + "img/hero.f0286f94.png";